import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import { API_LANGUAGE_MAPPING } from 'global/i18n/constants'
import { localeSelector } from 'global/i18n/selectors'
import { callApiAsync } from 'services/api/callAPIAsync'
import { forgottenPassword } from './reducer'

function* changeForgottenPasswordCallSaga(action) {
    const email = action?.payload?.email
    const url = window.location.origin
    const redirect_uri = `${url}/change-forgotten-password`
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)]

    yield put(startLoading())
    const { error } = yield call(callApiAsync, 'forgottenPassword', { email, language, url: redirect_uri })
    yield put(stopLoading())

    if (error) {
        console.error(error)
        yield put(setErrorMessage(error))
        return
    }

    yield put(setSuccessMessage('FORGOTTEN_PASSWORD'))
}

export default function* changeForgottenPasswordSaga() {
    yield all([takeLatest(forgottenPassword.type, changeForgottenPasswordCallSaga)])
}
